import { gql } from "@apollo/client";

export const GetStockManufacturers = gql`
  query GetStockManufacturers(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $orderBy: AtsStckManufacturerOrder
    $name: String
  ) {
    GetStockManufacturers(
      token: $token
      after: $after
      customer_id: $customer_id
      first: $first
      orderBy: $orderBy
      where: { or: [{ manufacturerContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          manufacturer
          slNo
          customerID
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

//By Ids

export const GetManufacturerByNodeId = gql`
  query GetManufacturerByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsStckManufacturer {
        manufacturer
        slNo
        customerID
      }
    }
  }
`;
